import { UserModel } from '@/models/UserModel'
import { computed, ref } from 'vue'

export const user = ref<Partial<UserModel>>({ can: () => false, hasRoles: () => false })
export const storageUrl = process.env.VUE_APP_STORAGE_URL + '/'
export const hasAiModule = computed(() => user.value.tenant?.modules?.includes('ai') ?? false)
